"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  rightShip: {
    menuName: '船舶评分',
    updateTime: '更新时间',
    ratingTime: '评分时间',
    vessel: '船舶',
    safetyRating: '安全评级',
    ghgRating: 'GHG评级',
    detail: "船舶评分详情",
    queryHistory: '历史评分'
  },
  amcl: {
    menuName: '数字化及节能技术应用情况统计表',
    totalCount: '统计',
    pleaseInput: '请输入内容',
    tipNoSelection: '未勾选任何项',
    tipNoData: '无数据能导出'
  },
  standardCodeCommon: {
    standardCode: '标准代码',
    portMile: '港对里程',
    activeFlag: '是否有效',
    effect: '生效',
    invalid: '失效',
    effect2: '启用',
    invalid2: '作废',
    pleaseEnter: '请输入内容',
    pleaseInput: '请输入',
    pleaseChoose: '请选择',
    remark: '备注',
    optionDate: '选择日期',
    selectTime: '选择时间',
    // 提示和校验
    saveSuccessfully: '保存成功',
    failSave: '保存失败',
    countryAreaCode: '国家地区代码',
    alreadyExistsCanSave: '已存在！不能保存',
    updateSuccessfully: '更新成功',
    searchFailure: '搜索失败',
    hint: '确定删除该条数据吗?',
    hintSome: '确认删除选中这些数据吗?',
    hintSome2: '当前页面修改未保存，是否保存并计算?',
    hintSome3: '请确认数据无误，是否进行计算',
    hintTitle: '提示',
    yes: '是',
    no: '否',
    successfullyDelete: '删除成功',
    sure: '确定要',
    thisData: '该数据吗？',
    modifySuccessfully: '修改成功',
    pleaseSelectData: '请选择一条数据',
    notBeEmpty: '不能为空',
    characterSize1: '长度在1到20个字符',
    characterSize2: '长度在1到100个字符',
    characterSize3: '长度在1到200个字符',
    characterSize4: '长度在1到500个字符',
    characterSize5: '长度在1到50个字符',
    characterSize6: '长度在1到10个字符',
    characterSize7: '长度在1到1000个字符',
    characterSize8: '长度在1到5个字符',
    pleaseSelectCountry: '请选择国家',
    pleaseSelectStatus: '请选择状态',
    failDelete: '删除失败',
    currencyCheckout: '您输入的货币代码已存在，不能保存',
    currencyNameCheckout: '您输入的货币名称已存在，不能保存',
    companyCodeCheckout: '您输入的公司编码已存在，不能保存',
    bankCodeCheckout: '您输入的银行编码已存在，不能保存',
    selectSpecificTime: '请选择具体时间',
    failedSaveChild: '保存子表失败',
    perfectForm: '请完善表单',
    singleCompany: '单船公司',
    typeAlready: '已存在该类型',
    completeFormCheckout: '不能为空，请完善表格',
    overlength: '超长',
    selectedCheckout: '是否删除已选择项?',
    operateSuccessfully: '操作成功',
    operationFailure: '操作失败',
    deletion: '是否确认删除?',
    selectData: '请选择数据',
    selectType: '请选择类型',
    selectAll: '请选择所有人',
    chooseDate: '请选择日期',
    selectCompany: '请选择公司'
  },
  // 国家地区
  country: {
    country: '国家/地区',
    countryInfo: '国家地区信息',
    countryCode: '国家/地区代码',
    countryNameCn: '国家/地区中文名',
    countryNameEn: '国家/地区英文名',
    europeanFlag: '是否欧盟国家'
  },
  // 货物种类
  goodsType: {
    goodsType: '货物种类',
    goodsTypeInfo: '货物种类',
    goodsTypeCode: '货物种类代码',
    cargoName: '货物种类名称',
    cargoNameCn: '货物种类中文名称',
    cargoGroupCode: '货物组别',
    isDanagerousCargo: '是否危险货物',
    GENERALCARGOES: '杂货',
    COAL: '煤',
    AGRICULTURALPRODUCTS: '农产品',
    NONMETALORE: '非金属矿石',
    STEELS: '钢铁',
    OTHER: '其他货类',
    CEMENT: '水泥',
    SALT: 'SALT',
    BUILDINGMATERIAL: '矿物性建筑材料',
    GRAIN: '粮食',
    TIMBER: '木材',
    Lightindustrialdrugs: '轻工药品',
    PETROLEUM: '石油',
    MACHINERYEQUIPMENT: '机械设备',
    METALALLOY: '合金',
    FERTILIZER: '化肥',
    ONDECKCARGOES: '甲板货',
    LNG: '液化气',
    METALORE: '金属矿石'
  },
  // 币种信息
  currency: {
    currency: '币种',
    currencyInfo: '币种信息',
    currencyCode: '货币代码',
    currencyName: '货币名称',
    currencySymbol: '货币符号'
  },
  // 城市信息
  cityInfo: {
    cityInfo: '城市信息',
    cityCode: '城市代码',
    cityNameCn: '城市中文名',
    cityNameEn: '城市英文名',
    countryCode: '国家/地区',
    province: '省份'
  },
  // 公司信息
  company: {
    companyInfo: '公司信息',
    companyCode: '公司编码',
    companyNameCn: '公司中文名',
    companyNameEn: '公司英文名',
    socialCreditCode: '统一社会信用编码',
    countryCode: '国家/地区',
    mnemonicNo: '助记码',
    registrationTime: '注册日期',
    registrationAddress: '注册地址'
  },
  // 汇率信息
  rate: {
    rateInfo: '汇率信息',
    currencyFrom: '原币种',
    currencyTo: '结算币种',
    effectDate: '生效时间',
    expireDate: '失效时间',
    dateRange: '生/失效时间',
    exchangeRate: '汇率'
  },
  // 港口信息
  port: {
    portInformation: '港口信息',
    portCode: '港口代码',
    portCodeTitle: '港口信息维护',
    portNameCn: '港口中文名',
    portNameEn: '港口英文名',
    countryCode: '国家/地区',
    sendPortMaster: '发送主数据',
    addPortMaster: '新增主数据',
    editPortMaster: '修改主数据'
  },
  portAssert: {
    tip: {
      checkAddPortMaster: '请选择仅一条数据',
      addSuccess: '新增成功',
      addError: '新增失败',
      editSuccess: '修改成功',
      editError: '修改失败',
      sending: '发送中，请等待 10~30s',
      sendSuccess: '发送成功',
      sendError: '发送失败'
    }
  },
  // 数据字典
  dataDictionary: {
    dictionary: '数据字典',
    codeType: '代码类型',
    codeName: '编码名称',
    codeLength: '编码长度',
    remark: '备注',
    codeTab: '字段信息',
    showSeq: '显示顺序',
    code: '编码',
    showVal: '显示值',
    showValCn: '显示值(中文)',
    relation: '自定义码',
    simpCode: '输入简码',
    remark2: '备注2',
    pleaseInput: '请输入代码类型',
    dictionaryAdd: '数据字典新增',
    dictionaryEdit: '数据字典编辑'
  },
  // 银行信息
  bankInfo: {
    bankInfomation: '银行信息',
    bankCode: '银行编码',
    bankName: '银行名称',
    bankCount: '银行账号',
    countryOrRegion: '国家/地区',
    countName: '账户名称',
    bankAds: '银行地址',
    bankCodeVal: '银行代码',
    receiptOrPaymentFlag: '收付标识',
    company: '所属公司',
    countType: '账户类型',
    companyCode: ' 公司编码',
    companyNameCn: '公司中文名',
    companyNameEn: '公司英文名',
    countryOrRegionCode: '国家/地区代码',
    countryOrRegionNameCn: '国家/地区中文名',
    countryOrRegionNameEn: '国家/地区英文名',
    receipt: '收',
    payment: '付',
    receiptOrPayment: '收/付',
    mulCurrency: '多种币',
    dollar: '美元',
    HKDollarDeposits: '港币存款',
    HKDollarCheck: '港币支票',
    notNull: '不能为空',
    pleaseChooseState: '请选择状态',
    pleaseChooseCompany: '请选择所属公司',
    pleaseChooseCount: '请选择银行账号'
  },
  // 业务科目
  costAccount: {
    title: '业务科目',
    assignmentMapping: '财务科目映射配置',
    showInvalid: '显示失效',
    showEffect: '显示生效',
    costCode: '费用科目代码',
    costName: '费用科目名称',
    costNameCn: '费用科目名称(中文)',
    businessType: '经营业务分类',
    safetyProductionType: '安全生产费类别',
    otherSafetyProductionType: '其他安全生产费类别',
    reportSeq: '报表序号',
    inputNum: '请输入数字',
    domesticTaxRate: '境内税率',
    isAssignmentMapping: '财务科目是否已分配映射',
    effectTime: '生效时间',
    invalidTime: '失效时间',
    costMsg: '业务科目信息',
    costMaintain: '业务科目维护',
    hasChild: '是否有子科目',
    isUsed: '业务是否可用',
    remark: '备注',
    companyNameCn: '公司中文名',
    companyNamECn: '公司英文名',
    company: '公司',
    creator: '创建人',
    yes: '是',
    no: '否',
    chooseDate: '请选择日期',
    enterCostCode: '请填写费用科目代码',
    enterCostName: '请填写费用科目名称',
    enterCostNameCn: '请填写费用科目名称(中文)',
    chooseEffectTime: '请选择生效时间',
    notNull: '不能为空',
    portVoyageCost: '航次成本'
  },
  // 数据库表
  dataBase: {
    dataForm: '数据库表',
    tableName: '表名',
    tableDesc: '表注释',
    focus: '关注船舶条件',
    columnName: '字段名',
    columnDesc: '字段描述',
    dataType: '字段类型',
    create: '数据库表新增',
    edit: '数据库编辑',
    tabaleNoEmpty: '表名不能为空',
    creator: '创建人',
    createTime: '创建时间'
  },
  //付款单财务审批人员配置
  paymentFinApproverConfiguration: {
    title: '付款单财务审批人员配置',
    handleUser: '处理人'
  },
  //公司印章配置
  companySealConfiguration: {
    company: '公司',
    seal: '印章',
    title: '公司印章配置',
    activeFlag: '是否启用',
    active: '启用',
    inactive: '禁用',
    isActive: '是否启用?',
    isInactive: '是否禁用?'
  }
};